<div class="mensaje-alerta error bounce" *ngIf="mostrarMensaje">
  <p>{{ mensaje }}</p>
</div>